import type { ReactNode } from "react";

import { cn } from "@/lib/cn";

export interface PanelProps {
  title?: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
  footer?: ReactNode;
  className?: string;
  bodyClassName?: string;
  children: ReactNode;
}

/** 原型基元：`.panel` / `.panel-heading` / `.panel-body`。 */
export function Panel({
  title,
  description,
  actions,
  footer,
  className,
  bodyClassName,
  children,
}: PanelProps) {
  return (
    <section className={cn("panel", className)}>
      {(title || actions) && (
        <header className="panel-heading">
          <div>
            {title ? <h3>{title}</h3> : null}
            {description ? <p>{description}</p> : null}
          </div>
          {actions}
        </header>
      )}
      <div className={cn("panel-body", bodyClassName)}>{children}</div>
      {footer}
    </section>
  );
}

export interface SectionTitleProps {
  title: ReactNode;
  description?: ReactNode;
  actions?: ReactNode;
}

/** 原型基元：`.section-title`。 */
export function SectionTitle({ title, description, actions }: SectionTitleProps) {
  return (
    <div className="section-title">
      <div>
        <h3>{title}</h3>
        {description ? <p>{description}</p> : null}
      </div>
      {actions}
    </div>
  );
}
